import {isSearchPage, ProductListState} from "../ProductListProvider";
import {UrlSearchParamsHelper} from "../../../../helpers/urlSearchParamsHelper";
import {getCorrectedMarginWeight, isPercentDiscountSetUnderMin} from "./percentDiscountHelper";

export const buildRequestString = (state: ProductListState): string => {
  if (!state.instance) {
    return "";
  }
  const {filter} = state.instance;
  filter.applyFilterValue(state.filters);

  const {customerId, customerGroupId, currencyCode, categoryId, offset, order, orderBy, limit} =
    state.instance.requestParams;

  const initParams = {customerId, customerGroupId, currencyCode, categoryId, offset, order, orderBy, limit} as {
    [k: string]: string | number;
  };

  const initParamsDestination = {};
  Object.keys(initParams)
    .filter(
      (requestParamKey) =>
        typeof initParams[requestParamKey] !== "undefined" &&
        initParams[requestParamKey] !== 0 &&
        requestParamKey !== "offset",
    )
    .forEach((key) => {
      if (key === "limit") {
        const limitSum = Number(initParams[key]) + Number(initParams.offset);
        initParamsDestination[key] = `${limitSum}`;
      } else {
        initParamsDestination[key] = initParams[key];
      }
    });

  const filterParams = {};
  Array.from(filter.filterItems.values())
    .filter((filterItem) => filterItem.paramValue)
    .forEach((filterItem) => {
      filterParams[filterItem.field] = filterItem.paramValue.split(",").sort().join(",");
    });

  const urlSearchParams = new URLSearchParams({...filterParams, ...initParamsDestination});
  const usp = new URLSearchParams(window.location.search);

  if (isSearchPage) {
    const possibleSearchQuery = usp.get("q");
    if (possibleSearchQuery) {
      urlSearchParams.append("q", possibleSearchQuery);
    }
    if (UrlSearchParamsHelper.promotions?.id) {
      urlSearchParams.append("promotionId", `${UrlSearchParamsHelper.promotions.id}`);
    }
  }

  const percentDiscountMinValue = isPercentDiscountSetUnderMin(state.instance, state.filters);
  if (percentDiscountMinValue) {
    urlSearchParams.append("percentageDiscount", `${percentDiscountMinValue}-`);
  }
  const marginWeight = usp.get("mw");
  if (marginWeight) {
    urlSearchParams.append("mw", getCorrectedMarginWeight(marginWeight));
  }

  return urlSearchParams.toString();
};
